import { RouterProvider } from 'react-router-dom';
import { AppRoutes } from './routes/routes';

export function App() {
  return (
    <>
      <RouterProvider router={AppRoutes()} />
    </>
  );
}
